<template>
    <div>
        <div class="py-2">
            <div class="flex">
                <div class="w-40">
                    <Popover class="relative">
                        <PopoverButton class="flex items-center">
                            <div class="mr-1 text-sm">
                                {{ label }}
                            </div>

                            <svg
fill="none" height="16" viewBox="0 0 16 16" width="16"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8 1.5C6.71443 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.75 4.5C7.89834 4.5 8.04334 4.54399 8.16668 4.6264C8.29002 4.70881 8.38615 4.82594 8.44291 4.96299C8.49968 5.10003 8.51453 5.25083 8.48559 5.39632C8.45665 5.5418 8.38522 5.67544 8.28033 5.78033C8.17544 5.88522 8.04181 5.95665 7.89632 5.98559C7.75084 6.01453 7.60004 5.99968 7.46299 5.94291C7.32595 5.88614 7.20881 5.79001 7.1264 5.66668C7.04399 5.54334 7 5.39834 7 5.25C7 5.05109 7.07902 4.86032 7.21967 4.71967C7.36033 4.57902 7.55109 4.5 7.75 4.5ZM8.5 11.5C8.23479 11.5 7.98043 11.3946 7.7929 11.2071C7.60536 11.0196 7.5 10.7652 7.5 10.5V8C7.3674 8 7.24022 7.94732 7.14645 7.85355C7.05268 7.75979 7 7.63261 7 7.5C7 7.36739 7.05268 7.24022 7.14645 7.14645C7.24022 7.05268 7.3674 7 7.5 7C7.76522 7 8.01957 7.10536 8.20711 7.29289C8.39465 7.48043 8.5 7.73478 8.5 8V10.5C8.63261 10.5 8.75979 10.5527 8.85356 10.6464C8.94733 10.7402 9 10.8674 9 11C9 11.1326 8.94733 11.2598 8.85356 11.3536C8.75979 11.4473 8.63261 11.5 8.5 11.5Z"
                                    fill="#828F9B"/>
                            </svg>
                        </PopoverButton>

                        <PopoverPanel
                            class="absolute z-10 left-0 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none px-4 py-3 text-sm">
                            <p class="mb-2 text-zinc-800 text-sm font-medium leading-tight">
                                {{ helpText }}
                            </p>

                            <p class="flex items-center text-gray-400">1
                                <svg
class="mx-1" fill="none" height="12" viewBox="0 0 12 12" width="12"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6 0.5L7.69282 4.17003L11.7063 4.6459L8.73904 7.38997L9.52671 11.3541L6 9.38L2.47329 11.3541L3.26096 7.38997L0.293661 4.6459L4.30718 4.17003L6 0.5Z"
                                        fill="#828F9B"/>
                                </svg>
                                = {{ lowScoreLabel }}
                            </p>
                            <p class="flex items-center text-gray-400">5
                                <svg
class="mx-1" fill="none" height="12" viewBox="0 0 12 12" width="12"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6 0.5L7.69282 4.17003L11.7063 4.6459L8.73904 7.38997L9.52671 11.3541L6 9.38L2.47329 11.3541L3.26096 7.38997L0.293661 4.6459L4.30718 4.17003L6 0.5Z"
                                        fill="#828F9B"/>
                                </svg>
                                = {{ highScoreLabel }}
                            </p>
                        </PopoverPanel>
                    </Popover>
                </div>

                <div>
                    <star-rating
                        :padding="4"
                        :round-start-rating="false"
                        :show-rating="false" :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" :star-size="20"
                        active-color="#111" class="mt-[-6px]" inactive-color="#e5e7eb" @update:rating="setRating"/>
                </div>
            </div>
            <InputError
                :message="errors[name]"
                class="mt-2"
            />
        </div>

        <div v-if="rating && rating < 4" class="p-1 mb-[8px] ">
            <div class="p-4 rounded-xl border border-gray-200">
                <div class="mb-[16px]">


                    <div class="font-medium text-sm mb-1 mt-1 text-zinc-800 leading-[14px] mb-[8px]">
                        Why did they lose marks here?<span class="text-red-500">*</span>
                    </div>
                    <div class="text-gray-400 text-sm font-medium leading-[14px]">
                        Please check all that apply.
                    </div>


                </div>

                <div class="mb-4">
                    <label v-for="(option, key) in options" :key="key" class="block text-sm mb-2 flex items-center">

                        <input
                            v-model="note"
                            :value="option"
                            class="h-4 w-4 rounded border-neutral-100 bg-neutral-100 text-zinc-800 focus:ring-gray-600 mr-2"
                            type="checkbox"
                            @change="noteChanged"
                        >
                        <span class=" text-zinc-800 text-sm font-medium leading-">{{ option }}</span>
                    </label>

                    <InputError
                        :message="errors[name + '_note']"
                        class="mt-2"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/Components/Legacy/Jetstream/Checkbox.vue';
import ReviewFormError from './ReviewFormError.vue';
import {Popover, PopoverButton, PopoverPanel} from '@headlessui/vue';
import {QuestionMarkCircleIcon} from '@heroicons/vue/24/outline/esm/index.js';
import InputError from '@/Components/Legacy/Jetstream/InputError.vue';
import {defineAsyncComponent} from 'vue';

export default {
    components: {
        InputError,
        Checkbox,
        StarRating: defineAsyncComponent(() =>
            import('vue-star-rating')
        ),
        ReviewFormError,
        Popover,
        PopoverButton,
        PopoverPanel,
        QuestionMarkCircleIcon
    },
    props: {
        errors: {
            type: Object,
            default: () => {
            }
        },
        label: {
            type: String,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        options: {
            type: Array,
            required: true
        },

        helpText: {
            type: String,
            required: true
        },

        lowScoreLabel: {
            type: String,
            required: true
        },

        highScoreLabel: {
            type: String,
            required: true
        },

        optional: {
            type: Boolean,
            default: false
        }
    },
    emits: ['selected'],

    data() {
        return {
            rating: null,
            note: []
        };
    },
    methods: {
        setRating(rating) {
            this.rating = rating;

            this.$nextTick(() =>
                this.$emit('selected', {name: this.name, value: rating})
            );
        },
        noteChanged() {
            this.$nextTick(() => {
                this.$emit('selected', {name: this.name + '_note', value: this.note.join(' & ')});
            });
        }
    }
};
</script>
